@if (isVisible()) {
  <div
    class="fixed inset-0 z-[9999] bg-black/95 cursor-pointer backdrop-blur-sm animate-in fade-in duration-300"
    (click)="onOverlayClick($event)">
    <button
      type="button"
      class="absolute top-4 right-4 z-10 w-10 h-10 flex items-center justify-center bg-white/10 hover:bg-white/20 hover:scale-110 active:scale-95 rounded-full transition-all duration-200 cursor-pointer"
      (click)="closeLightbox()">
      <span class="material-symbols-outlined text-white text-xl">close</span>
    </button>

    @if (hasMultipleImages()) {
      <button
        type="button"
        class="absolute left-4 top-1/2 -translate-y-1/2 z-10 w-12 h-12 flex items-center justify-center bg-white/10 hover:bg-white/20 hover:scale-110 active:scale-95 rounded-full transition-all duration-200 cursor-pointer"
        (click)="previous()">
        <span class="material-symbols-outlined text-white text-2xl">chevron_left</span>
      </button>

      <button
        type="button"
        class="absolute right-4 top-1/2 -translate-y-1/2 z-10 w-12 h-12 flex items-center justify-center bg-white/10 hover:bg-white/20 hover:scale-110 active:scale-95 rounded-full transition-all duration-200 cursor-pointer"
        (click)="next()">
        <span class="material-symbols-outlined text-white text-2xl">chevron_right</span>
      </button>

      <div
        class="absolute bottom-4 left-1/2 -translate-x-1/2 z-10 bg-black/50 backdrop-blur-sm rounded-full px-4 py-2 text-white text-sm">
        {{ currentIndex() + 1 }} / {{ images().length }}
      </div>
    }

    @if (!imageLoaded()) {
      <div class="absolute inset-0 flex items-center justify-center">
        <div class="animate-spin w-8 h-8 border-2 border-white/20 border-t-white rounded-full"></div>
      </div>
    }

    <div
      class="flex items-center justify-center h-full cursor-pointer"
      (click)="onOverlayClick($event)">
      <img
        [src]="imageUrl()"
        [alt]="altText() || 'Fullscreen image'"
        class="max-w-[90vw] max-h-[90vh] w-auto h-auto object-contain rounded-lg shadow-2xl cursor-default transition-opacity duration-300 select-none"
        style="user-drag: none; -webkit-user-drag: none"
        [class.opacity-0]="!imageLoaded()"
        [class.opacity-100]="imageLoaded()"
        (load)="onImageLoad()"
        (error)="closeLightbox()" />
    </div>
  </div>
}
